import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import ShopHome from './ShopHome';
import Cart from './Cart';
import CheckoutPage from './Checkout';
import ProductDetail from './ProductDetail';
import ProductList from './ProductList';

const styles = theme => ({
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    minHeight: '100vh',
    width: 'inherit',
    display: 'block', // Fix IE11 issue.
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up(900 + theme.spacing(3 * 2))]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
});

class ShopPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }


  render() {
    const { match, classes } = this.props;
    return (
      <div className={classes.page}>

        <Helmet>
          <title>Shop - Music, Routines + Videos</title>
          <meta name="description" content="Shop NiaNow for music, routines and videos. The NiaNow shop offers digital downloads, CDs and DVDs from your favorite Nia routines. " />
          <meta name="keywords" content="nia, shop, store, download, cd, dvd, music, routines, videos, album, playlist" />
        </Helmet>

        <NavBar />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Switch>
            <Route exact path={match.url + '/home'} component={ShopHome} />
            <Route exact path={match.url + '/cart'} component={Cart} />
            <Route exact path={match.url + '/checkout'} component={CheckoutPage} />
            {/* force remount by passing key */}
            <Route exact path={match.url + '/:category'} key={window.location.href} component={ProductList} />
            <Route path={match.url + '/product/:productId?'} key={window.location.href} component={ProductDetail} />
          </Switch>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

ShopPage.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(ShopPage));
